import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { EnrollmentTraductionDto } from "./enrollmentTraductionDto";

export class EnrollmentModificationDto {
    idEnrollmentBehaviorPatternModification?: number;
    codeModification?: string;
    active?: string;
    academicFeesCharge?: string;
    learningResourcesFee?: string;
    adminFeeCharge? : string;
    shortDescription?: string;
    enrollmentBehaviorPatternModificationTraductionDto? : EnrollmentTraductionDto[]
    typology?: string;

    constructor(data?: Partial<EnrollmentModificationDto>) {
        Object.assign(this, data);
    }
}

export class EnrollmentModificationResponse {
    EnrollmentModificationDto: EnrollmentModificationDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class EnrollmentModificationRequest {
    EnrollmentModificationDto: EnrollmentModificationDto = new EnrollmentModificationDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}